import firebase from 'firebase';
import $ from 'jquery';
import moment from 'moment';

const ajustaPropiedadesIndefinidas = (objetoBase, objetoNuevo) => $.extend(true, objetoBase, objetoNuevo);

const UUID = () => {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}
const accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u'}

const limpiarTextoTrimp = (palabra) => {

  let ret = '';
  for (var i = 0; i < palabra.length; i++) {
    ret += accent_map[palabra.charAt(i)] || palabra.charAt(i);
  }
  let str = ret.toLowerCase();
  return str.replace(/ /g,'')

}

const obtenerFechaConvertida = (fecha) => {

  if (fecha === null) {
    return fecha;
  }

  if (typeof fecha === 'string') {
    return moment(fecha).toDate()
  }

  if (typeof fecha === 'object') {
    if (fecha.seconds !== undefined) {
      return moment(fecha.seconds * 1000).toDate()
    }
  }

  return fecha;

}

const varificarFecha = (fecha, formatoRecibido='MM/DD/YYYY') => {

  if (!fecha) {
    return new Date();
  }

  if (typeof fecha === 'string') {
    return moment(fecha, formatoRecibido).toDate()
  }

  if (typeof fecha === 'object') {
    if (fecha.seconds !== undefined) {
      return moment(fecha.seconds * 1000).toDate()
    }
  }

  return fecha;

}

const listaMeses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
const listaDias = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sábado"]

const getFromFirebase = async (docRef) => {

  try {

    const doc = await docRef.get()
    if (!doc.exists) throw "El documento no existe"

    return doc.data()

  } catch (e) {

    throw e

  }

}

const objectToArray = (objecto) => {

  const lista = []

  for (const i in objecto) {
    lista.push({
      id: i,
      ...objecto[i],
    })
  }

  return lista

}

const alerta = {
  title: "¿Está seguro?",
  text: "",
  type: "info",
  showCancelButton: true,
  confirmButtonText: "Si",
  cancelButtonText: "No",
  showCloseButton: true,
  showLoaderOnConfirm: false
}

const ALERTA_INFO = { ...alerta }
//Alerta advertencia
const ALERTA_ADVERTENCIA = { ...alerta }
ALERTA_ADVERTENCIA.type = "warning";
//Alerta error
const ALERTA_ERROR = { ...alerta }
ALERTA_ERROR.type = "error";

const mergeOptions = {
  merge: true
}

/**
 * 
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} collection 
 */
const handleGetColecction = async (collection) => {

  const docs = await collection.get()

  const lista = []

  docs.forEach(e => {

    lista.push({
      ...e.data(),
      id: e.id,
    })

  })

  return lista

}

const getSnapshot = (doc) => doc.data() || {}

const obtenerIdMultiselect = (objeto) => {
  if (objeto) return objeto.id
  return null
}

const obtenerFechaString = (fecha = new Date()) => {

  const anio = fecha.getFullYear()
  const mes = listaMeses[fecha.getMonth()]
  const diaSemana = listaDias[fecha.getDay()]
  const dia = fecha.getDate()


  return `${diaSemana} ${twoDigits(dia)} de ${mes} de ${anio}`

}

export const twoDigits = (e) => ("0" + e).slice(-2)

const obtenerHoraString = (fecha = new Date()) => {

  const hora = fecha.getHours()
  const minutos = fecha.getMinutes()
  const formato = hora >= 12 ? 'PM' : 'AM'

  return `${twoDigits(hora)}:${twoDigits(minutos)} ${formato}`

}

const delay = (tiempo = 1000) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(), tiempo)
  })
}
/**
 * 
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} docRef
 * @param {String} campo 
 */
const handleSelectedFirebase = (docRef, filtro, campo) => {
  if(filtro.seleccionado){
    if(filtro.id){
      docRef = docRef.where(campo,'==',filtro.id)
    }
  }
  return docRef
}

/**
 * 
 * @param {String} title 
 * @param {String} body 
 * @returns 
 */
const obtenerCuerpoNotificacion = (title, body) => {

  title = title.length>35 ? `${title.substring(0, 35)}...` : title
  body = body.length>75 ? `${body.substring(0, 80)}...` : title

  return `
  <div class="snotifyToast__title">
    <h4>${title}</h4>
  </div>
  <div class="snotifyToast__body">
    <p>${body}</p>
  </div>
  `

}

export const obtenerMes = (fecha) => {
  return ("0" + (parseInt(fecha.getMonth())+1)).slice(-2)
}

export const timestampToDate = (fecha) => {
  return new Date(fecha.seconds * 1000)
}

const obtenerAnioMes = (fecha = new Date()) => {

  const mes = ("0" + (parseInt(fecha.getMonth())+1)).slice(-2)
  const anio = fecha.getFullYear()

  return `${anio}-${mes}`

}

const generarCorreoRandom = () => {
  
  const ramdom = new Date().getTime()
  return 'prop'+ramdom+'@pixancloud.com'

}

const formatoMonto = (e, simbol = '') => {
  if(!e) return `${simbol}0`
  return simbol+Number(e).toFixed(2).replace(/\B(?=(?:\d{3})+(?!\d))/g, ",")
}

export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export {
  generarCorreoRandom,
  formatoMonto,
  obtenerAnioMes,
  obtenerCuerpoNotificacion,
  obtenerHoraString,
  obtenerFechaString,
  ajustaPropiedadesIndefinidas,
  UUID,
  obtenerFechaConvertida,
  listaMeses,
  getFromFirebase,
  objectToArray,
  ALERTA_INFO,
  ALERTA_ADVERTENCIA,
  ALERTA_ERROR,
  mergeOptions,
  getSnapshot,
  obtenerIdMultiselect,
  delay,
  handleGetColecction,
  handleSelectedFirebase,
  limpiarTextoTrimp,
  varificarFecha
};




// WEBPACK FOOTER //
// ./src/constantes/helpers.js